export class DateHelper {
  static format(date: Date, format = 'yyyy-MM-dd HH:mm:ss'): string {
    format = format.replace(/yyyy/, date.getFullYear().toString())
      .replace(/yy/, date.getFullYear().toString().substring(2))
      // 注意：原来的 'y' 替换可能不需要特别处理，这里保持简单
      .replace(/MM/, (date.getMonth() + 1).toString().padStart(2, '0'))
      .replace(/dd/, date.getDate().toString().padStart(2, '0'))
      .replace(/M/, (date.getMonth() + 1).toString())
      .replace(/d/, date.getDate().toString())
      .replace(/HH/, date.getHours().toString().padStart(2, '0'))
      .replace(/hh/, (date.getHours() % 12 || 12).toString().padStart(2, '0')) // 使用 % 12 来处理12小时制
      .replace(/mm/, date.getMinutes().toString().padStart(2, '0'))
      .replace(/ss/, date.getSeconds().toString().padStart(2, '0'))
      .replace(/H/, date.getHours().toString())
      .replace(/h/, (date.getHours() % 12 || 12).toString()) // 同上，处理12小时制
      .replace(/m/, date.getMinutes().toString())
      .replace(/s/, date.getSeconds().toString());
    return format;
  }
}
